<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-t"><a id="page_2">Dedicated to Madeline Mattaini</a></p><a id="page_2">
<p class="ded0">who died of diphtheria in January</p>
<p class="ded0">1932 in her 19th year</p>
<p class="ded">and</p>
<p class="ded">Neil Mattaini who died in an</p>
<p class="ded0">automobile accident in June 1932</p>
<p class="ded0">in his 21st year</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Dedication.vue?12c144f3